var ko = require('knockout');

ko.components.register('read-more-popup', {
  viewModel: require('./read-more-popup'),
  template: require('./read-more-popup.template')
});
